function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#009b3a"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fedf00",
  d: "M10 16l-8-6 8-6 8 6-8 6z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 3,
  fill: "#002776"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8.5a5.85 5.85 0 00-.6 0 3 3 0 00-.36 1 7.5 7.5 0 01.96 0c2.27 0 4.19 1 4.45 2.22a2.83 2.83 0 00.5-1.24A6.16 6.16 0 008 8.5z",
  fill: "#f0f0f0"
});

function SvgBr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDA5YjNhO30uY2xzLTJ7ZmlsbDojZmVkZjAwO30uY2xzLTN7ZmlsbDojMDAyNzc2O30uY2xzLTR7ZmlsbDojZjBmMGYwO308L3N0eWxlPjwvZGVmcz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIi8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEwIDE2IDIgMTAgMTAgNCAxOCAxMCAxMCAxNiIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iMTAiIGN5PSIxMCIgcj0iMyIvPjxwYXRoIGNsYXNzPSJjbHMtNCIgZD0iTTgsOC41YTUuODUsNS44NSwwLDAsMC0uNiwwLDMsMywwLDAsMC0uMzYsMUE3LjUsNy41LDAsMCwxLDgsOS41YzIuMjcsMCw0LjE5LDEsNC40NSwyLjIyYTIuODMsMi44MywwLDAsMCwuNS0xLjI0QTYuMTYsNi4xNiwwLDAsMCw4LDguNVoiLz48L3N2Zz4=";
export { SvgBr as ReactComponent };